module.exports = __webpack_public_path__ + "media/images/logo_paytotal-cc540b5b6f17eb26fd04d41bfa077b5a.png";